import { render, staticRenderFns } from "./CompanyDefaultMappingsDialog.vue?vue&type=template&id=a21c9304&scoped=true"
import script from "./CompanyDefaultMappingsDialog.vue?vue&type=script&lang=js"
export * from "./CompanyDefaultMappingsDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanyDefaultMappingsDialog.vue?vue&type=style&index=0&id=a21c9304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21c9304",
  null
  
)

export default component.exports